"use client";
import { useEffect, useRef, useState } from "react";

import { useWeb3Context } from "@/contexts/web3";
import { useRequest } from "@/hooks/use-request/use-request";
import { ApiPoolAprResponse } from "@/types/api";

export const useAprMap = (poolsIds: string[]) => {
  const { internalChainId } = useWeb3Context();

  const { request } = useRequest();
  const [poolsApr, setPoolsApr] =
    useState<Record<string, ApiPoolAprResponse>>();
  const previousPools = useRef<string[]>();

  useEffect(() => {
    if (!internalChainId) return;
    if (previousPools.current?.toString() === poolsIds.toString()) return;
    const fetchApr = async () => {
      const aprList = await Promise.all(
        poolsIds.map((poolId) =>
          request<ApiPoolAprResponse>(
            `chain/${internalChainId}/marginlypool/${poolId}/apr`,
          ),
        ),
      );
      const aprMap = aprList.reduce((acc, d, i) => {
        return { ...acc, [poolsIds[i] || ""]: d };
      }, {} as Record<string, ApiPoolAprResponse>);
      setPoolsApr(aprMap);
    };
    fetchApr();
  }, [internalChainId, poolsIds, request]);

  useEffect(() => {
    if (!internalChainId) return;
    previousPools.current = poolsIds;
  }, [internalChainId, poolsIds]);

  return poolsApr;
};
